import { combineReducers } from 'redux'
import particlesReducer from './ParticlesReducer'
import sectionsReducer from './SectionsReducer'
import configReducer from './ConfigReducer'


export default combineReducers({
  particlesReducer,
  sectionsReducer,
  configReducer
})


// WEBPACK FOOTER //
// ./src/reducers/index.js